import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"grid-list-xl":"","fluid":""}},[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,[_vm._v("\n    Тут менеджер/админ может изменить свои данные: имя, телефон, пароль....\n    ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }